import { styled } from '@mui/material';

import { useMemo } from 'react';

import { TCurrentUserTeamDto } from '@app-velocity/av-api-v2';

import { useI18n } from '@app-velocity/i18n';

import { TeamTypeBadge } from '@app-velocity/ui';

import { TeamLogo } from '../TeamLogo';

export type SingleTeamProps = {
  team: TCurrentUserTeamDto & { workspaceId: string };
};

const StyledSingleTeam = styled('div')(({ theme }) => ({
  display: 'flex',
  overflow: 'hidden',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'space-between'
}));

const StyledTeamDetails = styled('div')({
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column',
  justifyContent: 'center',
  marginRight: 8,
  flex:1
});

const StyledSingleTeamName = styled('span')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  lineHeight: 1.1,
  fontWeight: 500,
  margin: 0,
  fontSize: 16,
});

const StyledTeamRole = styled('span')({
  fontSize: 10,
});

export const SingleTeam = ({ team }: SingleTeamProps) => {
  const { t } = useI18n();

  const roleLabel = useMemo(() => {
    switch (team.userRole) {
      case 'ADMIN': {
        return t('teams:role.admin');
      }

      case 'OWNER': {
        return t('teams:role.owner');
      }

      case 'MEMBER': {
        return t('teams:role.member');
      }

      default:
        return '-';
    }
  }, [team.userRole, t]);

  return (
    <StyledSingleTeam data-testid="single-team">
      <TeamLogo />
      <StyledTeamDetails>
        <StyledSingleTeamName data-testid="team-name">
          {team.teamName}
        </StyledSingleTeamName>
        <StyledTeamRole>{roleLabel}</StyledTeamRole>
      </StyledTeamDetails>
      <TeamTypeBadge tier={team.subscriptionTier} />
    </StyledSingleTeam>
  );
};
